import { useCallback, useState } from 'react';

import TranslateRoundedIcon from '@mui/icons-material/TranslateRounded';
import { IconButton, ListItemIcon, Menu, MenuItem, Tooltip, Typography } from '@mui/material';

import { useLocale } from '@/shared/i18n';
import { LOCALE_LABELS, SUPPORTED_LOCALES } from '@/shared/i18n';
import type { SupportedLocale } from '@/shared/i18n';

import { CountryFlag } from './CountryFlag';

export function LanguageSwitcher() {
  const { locale, setLocale } = useLocale();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleOpen = useCallback((event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  }, []);

  const handleClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  const handleSelect = useCallback(
    (selected: SupportedLocale) => {
      setLocale(selected);
      setAnchorEl(null);
    },
    [setLocale],
  );

  return (
    <>
      <Tooltip title="Language / Язык / 语言">
        <IconButton
          onClick={handleOpen}
          size="small"
          aria-label="Change language"
          aria-controls={open ? 'language-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          color="inherit"
        >
          <TranslateRoundedIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <Menu
        id="language-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        {SUPPORTED_LOCALES.map((code) => (
          <MenuItem
            key={code}
            selected={code === locale}
            onClick={() => { handleSelect(code); }}
            dense
          >
            <ListItemIcon sx={{ minWidth: 32 }}>
              <CountryFlag locale={code} />
            </ListItemIcon>
            <Typography variant="body2">{LOCALE_LABELS[code]}</Typography>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
